import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import clsx from 'clsx'
import { CheckIcon, ChevronDownIcon } from 'lucide-react'
import { useEffect, useState } from 'react'

export type FilterButtonModel = {
  name: string
  label: string
  index: number
}

type Props = {
  selectedIndex: number
  setSelectedIndex: (index: number) => void
  filterButtons: FilterButtonModel[]
  minWidth?: string
  maxWidth?: string
}

export const MobileFilterButtons = ({
  filterButtons,
  minWidth = '180px',
  maxWidth = '250px',
  selectedIndex,
  setSelectedIndex,
}: Props) => {
  const [selected, setSelected] = useState<FilterButtonModel>(filterButtons[0])

  useEffect(() => {
    const matching = filterButtons.find((btn) => btn.index === selectedIndex)
    if (matching) {
      setSelected((prev) => {
        // Обновляем только если индекс изменился
        if (prev.index !== matching.index) {
          return matching
        }
        return prev
      })
    }
  }, [selectedIndex, filterButtons])

  const handleSelected = (value: FilterButtonModel) => {
    setSelected(value)
    setSelectedIndex(value.index)
  }

  return (
    <div className="w-full" style={{ minWidth, maxWidth }}>
      <Listbox value={selected} onChange={handleSelected}>
        <ListboxButton
          className={clsx(
            'relative block w-full rounded-lg bg-white dark:bg-card-background py-2 pl-2 text-left text-sm/6 text-primary dark:text-primary-dark ring-1 ring-inset ring-current',
            'focus:outline-none data-[focus]:outline-2 data-[focus]:-outline-offset-2 data-[focus]:outline-card-border'
          )}
        >
          {selected.name}
          <ChevronDownIcon
            className="group pointer-events-none absolute right-2 top-[10px] w-5 h-5"
            aria-hidden="true"
          />
        </ListboxButton>
        <ListboxOptions
          anchor="bottom"
          transition
          className={clsx(
            'w-[var(--button-width)] rounded-xl ring-1 ring-inset ring-card-border dark:ring-card-border-dark bg-white dark:bg-card-background p-1 [--anchor-gap:var(--spacing-1)] focus:outline-none',
            'transition duration-100 ease-in data-[leave]:data-[closed]:opacity-0'
          )}
        >
          {filterButtons.map((button) => (
            <ListboxOption
              key={button.index}
              value={button}
              className="group flex cursor-default items-center gap-2 rounded-lg py-1.5 px-3 select-none data-[focus]:bg-light-purple dark:data-[focus]:bg-dark-purple"
            >
              <CheckIcon className="invisible size-4 group-data-[selected]:visible" />
              <div className="text-sm/6 text-text-main dark:text-white">{button.name}</div>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </Listbox>
    </div>
  )
}
